import React from 'react'
import { useLocation, useParams } from 'react-router-dom'

export default function BackGroundForPlog() {

    const { text } = useParams();


    return (
        <header className="relative bg-black w-full h-[30vh] lg:h-[45vh]">
            <div className="absolute inset-0 top-1/3 z-10 flex flex-col items-center justify-center text-center px-4 content-visibility-auto">
                <h1 className="text-white text-4xl lg:text-5xl font-bold mb-4">
                   المدونه
                </h1>
                <p className="text-[#ffffffbc] md:w-[30%] mx-auto mb-6">
                    {decodeURIComponent(text)}
                </p>
            </div>
        </header>
    )
}
